"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenGraphTags = void 0;
const react_1 = __importDefault(require("react"));
const OpenGraphImageTag_1 = require("./OpenGraphImageTag");
const OpenGraphTags = ({ description, imageUrl, title = "Eventbrite", type = "website", url, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("meta", { property: "og:site_name", content: "Eventbrite" }),
    react_1.default.createElement(OpenGraphImageTag_1.OpenGraphImageTag, { imageUrl: imageUrl }),
    react_1.default.createElement("meta", { property: "og:title", content: title }),
    description && react_1.default.createElement("meta", { property: "og:description", content: description }),
    react_1.default.createElement("meta", { property: "og:url", content: url }),
    react_1.default.createElement("meta", { property: "og:type", content: type })));
exports.OpenGraphTags = OpenGraphTags;
//# sourceMappingURL=OpenGraphTags.js.map